import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTenancy, useKeyDocuments } from '@/contexts/TenancyContext';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from "@awesome.me/kit-269fbef2e2/icons/duotone/solid";
import { handleNavigation } from '@/utils/navigation-utils';

const KeyDocuments: React.FC = () => {
  const { keyDocumentItems, loading } = useKeyDocuments();
  const { activeTenancy } = useTenancy();
  const navigate = useNavigate();

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Key Documents</h1>
      {loading ? (
        <p className="text-muted-foreground">Loading Documents...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {keyDocumentItems.map((item, idx) => {
            // Check the structure of the icon
            return (
              <Card
                key={idx}
                className="cursor-pointer transition-all duration-300 hover:shadow-md border border-border hover:border-primary/30 overflow-hidden flex items-center"
                onClick={() => {
                  if (item.url) {
                    handleNavigation(item.url, navigate, undefined, item.routeName);
                  }
                }}
              >
                <CardHeader className="flex flex-row items-center gap-4 px-4 w-full h-full">
                  <div className="flex-shrink-0 w-12 h-12 rounded-full bg-muted dark:bg-muted/40 flex items-center justify-center text-primary text-xl">
                    {React.isValidElement(item.icon) ? 
                      item.icon : 
                      React.createElement(
                        typeof item.icon === 'function' ? item.icon : () => <FontAwesomeIcon icon={faFileAlt} />,
                        { className: "text-primary" }
                      )}
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-lg md:text-base sm:text-sm whitespace-normal break-words line-clamp-2">{item.title}</CardTitle>
                    <CardDescription className="mt-1 text-sm md:text-xs sm:text-[0.7rem] whitespace-normal break-words line-clamp-2">{item.subtitle}</CardDescription>
                  </div>
                  <div className="flex-shrink-0 text-primary">
                    <i className="fa-duotone fa-arrow-right" aria-hidden="true" />
                  </div>
                </CardHeader>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default KeyDocuments;